// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".label-search-btn{height:36px;line-height:36px;padding:0 20px}", ""]);
// Exports
module.exports = exports;
